<template>
  <q-dialog
    v-model="shown"
    data-test-id="modify-member-details-dialog"
    @hide="$emit('hide')"
  >
    <q-card
      class="q-pb-lg"
      style="width: 100%; max-width: 600px;"
    >
      <member-form
        v-show="showMemberForm"
        ref="memberForm"
        :embedded-in-model-table="false"
        simplify

        @apply-changes="memberFormApplyChanges()"
        @add-model="memberFormApplyChanges()"
      />
      <div class="row q-ma-sm text-center items-center q-gutter-sm">
        <div class="col" />
        <div class="col-auto text-h6 title">
          {{ $t('pages.modifyMembership.heading') }}
        </div>
        <div class="col" />
      </div>
      <q-card-section
        v-if="membership && membership.loaded"
        class="q-gt-sm-mx-xl q-px-xl q-my-lg"
      >
        <q-list
          v-if="membership.members.data.length"
          bordered
          separator
        >
          <q-slide-item
            v-for="member in membership.members.data"
            :key="member.id"
            @click="editUser(member)"
          >
            <q-item
              class="row"
            >
              <q-item-section>
                <q-item-label
                  overline
                  class="text-uppercase"
                >
                  {{ member.name }}
                </q-item-label>
              </q-item-section>

              <q-item-section>
                <membership-type-chip
                  :user="member"
                  :clickable="false"
                />
              </q-item-section>

              <q-item-section
                class="text-center text-body2"
              >
                <i18n-n
                  :value="membershipRateDisplayTotal(member.membershipMonthlyRate)"
                  format="currency"
                />/{{ membershipRateDisplayPeriod() }}
              </q-item-section>
              <q-item-section
                class="col-auto"
                style="width: 24px;"
              >
                <q-icon
                  v-if="member.type === USER_TYPES.GUEST"
                  size="sm"
                  name="info"
                  color="warning"
                >
                  <q-tooltip>
                    Details required
                  </q-tooltip>
                </q-icon>
              </q-item-section>
            </q-item>
          </q-slide-item>
        </q-list>
      </q-card-section>
      <q-card-section
        class="row justify-center q-gutter-sm"
      >
        <q-btn
          :label="$t('membership.actions.modifyMembership')"
          color="positive"
          outline
          @click="modifyMembership"
        />
      </q-card-section>
      <q-card-actions
        class="row justify-between q-mx-xl q-px-lg"
      >
        <div class="text-h5">
          <i18n-n
            :value="membershipRateDisplayTotal(membership.monthlyRate)"
            format="currency"
          />
          / {{ membershipRateDisplayPeriod() }}
        </div>
        <q-btn
          v-close-popup
          label="Done"
          color="primary"
        />
      </q-card-actions>
      <q-inner-loading :showing="membership.loading" />
    </q-card>
  </q-dialog>
</template>

<script>
import Membership from 'src/models/membership/Membership'
import User, { USER_TYPES } from 'src/models/user/User'
import MemberForm from 'src/modules/register/membership/MemberForm'
import MembershipTypeChip from 'src/modules/register/membership/MembershipTypeChip'

export default {
  name: 'ModifyMemberDetailsForm',
  components: {
    MemberForm,
    MembershipTypeChip
  },
  context: ['currentUser'],
  configuration: ['currentCircuit'],
  props: {
    membership: {
      type: Membership,
      required: true
    }
  },
  emits: ['hide'],
  data () {
    return {
      shown: false,
      showMemberForm: true,
      editingUser: null,
      loading: false
    }
  },
  created () {
    _.extend(this, { USER_TYPES })
  },
  methods: {
    show () {
      this.shown = true
    },
    memberFormApplyChanges () {
      this.editingUser.save()
      this.showMemberForm = false
    },
    async selectUser (user) {
      const userDetails = new User({ id: user.id },
        {
          membership: {
            currentMembershipInterval: 'default'
          },
          userClass: true,
          membershipType: true
        }
      )
      await userDetails.fetch()
      this.foundUser(userDetails)
    },
    editUser (user, initialData = {}) {
      this.editingUser = user
      user.membership = !user.membership || user.membership.clone() // Need to unset or when the member form gets destroyed, so will the membership model
      this.showMemberForm = true
      this.$refs.memberForm.show(user, initialData)
    },
    membershipRateDisplayTotal (monthlyRate) {
      return monthlyRate * this.currentCircuit.membershipRateDisplayPeriod
    },
    membershipRateDisplayPeriod () {
      switch (this.currentCircuit.membershipRateDisplayPeriod) {
        case 1:
          return 'month'
        case 12:
          return 'year'
        default:
          // Something has gone wrong
          return 'month'
      }
    },
    modifyMembership () {
      this.$router.push('/checkout/modify-membership')
    }
  }
}

</script>

<style lang="scss" scoped>
  .title {
    font-family: "Roboto", "-apple-system", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  .selected {
    border: solid 4px;
    border-radius: 10px;
    border-color: var(--q-primary);
  }
</style>
